import styled from 'styled-components'

export const OverlapHeroWrapper = styled.section`
  width: 100vw;
  height: 500px;
  padding-bottom: 15rem;
  @media only screen and (max-width: 748px) {
    padding-bottom: 8rem;
  }
  position: relative;
  .overlapHero {
    width: 100vw;
    height: 500px;
    @media only screen and (max-width: 748px) {
      height: 250px;
      padding-bottom: 8rem;
    }
    @media only screen and (max-width: 448px) {
      height: 180px;
    }
  }
`

export const Overlap = styled.div`
  @media only screen and (min-width: 750px) {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0 auto;
  }
  @media only screen and (max-width: 750px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  background-color: white;
  max-width: 800px;
  z-index: 20;
  text-align: center;
  > h4 {
    max-width: 600px;
    @media only screen and (min-width: 748px) {
      min-width: 500px;
    }

    padding: 2rem 2rem;
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 1.4;
  }
`

export const AvatarWrapper = styled.div`
  border-radius: 50%;
`

export const ProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1.8rem;
`

export const ProfileText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  margin-left: 1.75rem;
  font-size: 1.125rem;
  > h5 {
    color: ${({ theme }) => theme.colors.primary};
    letter-spacing: 0.12px;
    margin-bottom: 4px;
  }
  > p {
    font-weight: 300;
    font-size: 18px;
  }
`
